<template>
  <transition name="fade" v-if="rejectNoties.length > 0">
    <div class="profileDrop" v-if="isShowAlert">
      <div class="box-alert">
        <div class="item-alert">
          <p>
            등록하신 제품·서비스가 거절되었습니다.
          </p>
          <p class="alignR mt-5">
            <router-link style="display: inline-block;" :to="routerPath">
              <button class="btn-main btn-primary bordered btn-small">
                확인하러가기
              </button>
            </router-link>
            <button
              class="btn-main btn-outline-secondary bordered ml-3 btn-small"
            >
              취소
            </button>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { ROLE } from "@/data/role";
import { mapState } from "vuex";
export default {
  name: "PopupHeaderNotify",
  computed: {
    ...mapState("auth", ["user", "rejectNoties", "showNoti"]),
    routerPath() {
      if (this.rejectNoties[0].type === "product") {
        return "/corp/productEnroll/" + this.rejectNoties[0].IDX;
      } else if (this.rejectNoties[0].type === "service") {
        return "/corp/serviceEnroll/" + this.rejectNoties[0].IDX;
      } else if (this.rejectNoties[0].type === "matching") {
        if (this.user.roleName == ROLE.CORP) {
          return `/corp/myMatching?requestIdx=${this.rejectNoties[0].idx}&stauts=${this.rejectNoties[0].status}`;
        } else {
          return `/user/myMatching?requestIdx=${this.rejectNoties[0].idx}&stauts=${this.rejectNoties[0].status}`;
        }
      }
      return "#";
    },
  },
};
</script>
